/**
 * NIS2 Score: 40% SA + 60% Controls
 */
export type Nis2ControlStatus = 'IMPLEMENTED' | 'PARTIAL' | 'NOT_IMPLEMENTED' | 'N_A';
const STATUS_TO_PERCENT: Record<Nis2ControlStatus, number | null> = {
  IMPLEMENTED: 100, PARTIAL: 50, NOT_IMPLEMENTED: 0, N_A: null,
};
function normalizeStatus(s: string | undefined | null): Nis2ControlStatus | null {
  if (!s || typeof s !== 'string') return null;
  const u = s.toUpperCase().replace(/\s+/g, '_');
  if (['IMPLEMENTED', 'PARTIAL', 'NOT_IMPLEMENTED', 'N_A', 'NA'].includes(u)) return (u === 'NA' ? 'N_A' : u) as Nis2ControlStatus;
  return null;
}
export function computeNis2ControlsScore(controlsAnswers: Record<string, string>) {
  const breakdown = { implemented: 0, partial: 0, notImplemented: 0, na: 0, totalNonNA: 0 };
  let sum = 0;
  for (const raw of Object.values(controlsAnswers)) {
    const status = normalizeStatus(raw);
    if (!status) continue;
    if (status === 'N_A') { breakdown.na++; continue; }
    breakdown.totalNonNA++;
    const pct = STATUS_TO_PERCENT[status];
    if (pct !== null) sum += pct;
    if (status === 'IMPLEMENTED') breakdown.implemented++;
    else if (status === 'PARTIAL') breakdown.partial++;
    else breakdown.notImplemented++;
  }
  const score = breakdown.totalNonNA > 0 ? Math.round((sum / (breakdown.totalNonNA * 100)) * 100) : 0;
  return { score, breakdown };
}
export function computeNis2Score(params: { selfAssessmentScore?: number; controlsScore?: number }): number {
  const sa = typeof params.selfAssessmentScore === 'number' && Number.isFinite(params.selfAssessmentScore) ? Math.max(0, Math.min(100, params.selfAssessmentScore)) : 0;
  const ctrl = typeof params.controlsScore === 'number' && Number.isFinite(params.controlsScore) ? Math.max(0, Math.min(100, params.controlsScore)) : 0;
  if (sa === 0 && ctrl === 0) return 0;
  return Math.round(0.4 * sa + 0.6 * ctrl);
}
